export default __webpack_public_path__ + "static/media/foothillfitness-ss.21f9d542.png";